import { cn } from '../../utils/classNames';

// Backdrop for the mobile sidebar drawer. Sidebar itself is rendered inline
// by AppShell with mobileOpen=true — layout.css slides it via
// `.lk-side--open { transform: translateX(0) }` inside the ≤899px media query.
// This component only owns the click-outside backdrop overlay.
export function MobileDrawer({ open, onClose }) {
  return (
    <div
      className={cn('lk-side-backdrop', open && 'lk-side-backdrop--open')}
      onClick={onClose}
      aria-hidden={!open}
    />
  );
}
